import React, { useState, useEffect } from "react";
import "./navbar.css";

const links = [
  { name: "Home", id: "home" },
  { name: "Skills", id: "skills" },
  { name: "Projects", id: "projects" },
  // { name: "Contact", id: "footer" }
];

export default function Navbar() {
  const [active, setActive] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setActive(id);
    setMenuOpen(false);
  };

  const handleHireMe = () => {
    window.location.href =
      "mailto:amarbraha1@email.com?subject=Hire%20Inquiry&body=Hi%20Amar%2C%20I%27d%20like%20to%20hire%20you%20for%20a%20project!";
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-inner">
        <div className="navbar-logo">AB</div>

        <ul className="navbar-links">
          {links.map((link) => (
            <li key={link.name}>
              <button
                className={`nav-link ${active === link.id ? "active" : ""}`}
                onClick={() => scrollToSection(link.id)}
              >
                {link.name}
              </button>
            </li>
          ))}
        </ul>

        <button className="nav-hire" onClick={handleHireMe}>
          Hire Me
        </button>

        <button
          className={`nav-burger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className={`navbar-mobile ${menuOpen ? "open" : ""}`}>
        {[...links.map((l) => l.name), "Hire Me"].map((link, linkIndex) => (
          <button
            key={link}
            className={`mobile-link ${active === (link === "Hire Me" ? "footer" : links.find((l) => l.name === link)?.id) ? "active" : ""} ${link === "Hire Me" ? "mobile-hire" : ""}`}
            onClick={() => {
              if (link === "Hire Me") {
                handleHireMe();
              } else {
                const linkObj = links.find((l) => l.name === link);
                if (linkObj) scrollToSection(linkObj.id);
              }
              setMenuOpen(false);
            }}
          >
            <span className="mobile-link-word">
              {link.split("").map((char, charIndex) => (
                <span
                  key={charIndex}
                  className="mobile-link-char"
                  style={{
                    "--link-i": linkIndex,
                    "--char-i": charIndex,
                    "--total-chars": link.length,
                  }}
                >
                  {char === " " ? "\u00A0" : char}
                </span>
              ))}
            </span>
          </button>
        ))}
      </div>
    </nav>
  );
}
